<template>
  <div class="history-list-container">
    <div v-if="record.length === 0 && !loading && !firstLoad" class="no-data">
      <i><img :src="$getThemeImagePath('no-data.png')" alt=""></i>
      <p>{{ $t('Bao.no_relevant_data_records') }}</p>
      <span>{{ $t('Bao.search_results_are_empty') }}</span>
    </div>
    <template v-else-if="record.length > 0">
      <div class="con-list-frame">
        <div class="h-dataTitle colu-state">
          <span class="fs-14px fw-700">{{ $t("Bao.status") }}</span>
        </div>
        <div class="h-dataTitle colu-amount">
          <span class="fs-14px fw-700">{{ $t("Bao.deposit_receive") }}</span>
        </div>
      </div>

      <div v-for="(item, key) in record" :key="key" class="con-list-frame goTo-data-popup" @click="showHistoryModal(item)">
        <div class="h-dataTitle colu-state">
          <div class="state-container">
            <div class="state-box">
              <span class="fs-14px">{{ item.status_label }}</span>
            </div>
            <div class="state-date">
              {{ item.formattedTime }}
            </div>
          </div>
        </div>
        <div class="h-dataTitle colu-amount">
          <div class="amount-container">
            <div class="amount-box">
              <span class="fs-14px">{{ item.actual_amount | numberFormatFull }}</span>
              <img class="his-icon" :src="item.image">
            </div><i class="fa-solid fa-angle-right" aria-hidden="true" />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: 'DepositHistory',
  props: {
    record: {
      type: Array,
      default: () => ([])
    },
    loading: {
      type: Boolean,
      default: false
    },
    firstLoad: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {
    showHistoryModal(item) {
      this.$emit('show-history-modal', item)
    }
  }
}
</script>
